import { render, staticRenderFns } from "./FmRadioDemo.vue?vue&type=template&id=646bd1a6&scoped=true&"
import script from "./FmRadioDemo.vue?vue&type=script&lang=js&"
export * from "./FmRadioDemo.vue?vue&type=script&lang=js&"
import style0 from "./FmRadioDemo.vue?vue&type=style&index=0&id=646bd1a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646bd1a6",
  null
  
)

export default component.exports